import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import { getRelatedIds } from '@/parcels/pages/ParcelsPage/pages/ParcelsListPage/helpers'
import parcelServices from '@/parcels/services/services'

import { getPackableParcels } from './helpers'

const useGeneratePackingList = ({ storeId, setToastInfo, setSelectedParcels, selectedParcels }) => {
  const [showGeneratePackingListModal, setShowGeneratePackingListModal] = useState(false)

  const { fetchData: generatePackingList, loading: generatingPackingList } = useFetch(
    parcelServices.generatePackingList,
    {
      doInitialRequest: false,
    }
  )

  const openGeneratePackingListModal = () => {
    setShowGeneratePackingListModal(true)
  }

  const closeGeneratePackingListModal = () => {
    setShowGeneratePackingListModal(false)
  }

  const onGeneratePackingList = async parcelIds => {
    try {
      const response = await generatePackingList({
        storeId,
        payload: { ids: getRelatedIds(selectedParcels, parcelIds) },
      })

      if (response?.file_url) {
        window.open(response?.file_url, '_blank', 'noopener, noreferrer')
      }

      closeGeneratePackingListModal()
      setSelectedParcels([])
    } catch (error) {
      closeGeneratePackingListModal()
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    showGeneratePackingListModal,
    openGeneratePackingListModal,
    closeGeneratePackingListModal,
    generatingPackingList,
    onGeneratePackingList,
    packableParcels: getPackableParcels(selectedParcels),
  }
}

export default useGeneratePackingList
